import React from 'react';
import { Checkout } from '../../../../../common/types/checkout';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../../../common/utils/format-currency';
import * as S from './order-summary-torn.style';

type Props = {
  checkout: Checkout;
  uiOrderBumpsAplicados?: Array<{
    id: string;
    produtoOferta?: { nome?: string };
    precos?: Array<{ valor: number }>;
  }>;
  uiSubtotal?: number;
  discount: number;
};

export const OrderSummaryTorn: React.FC<Props> = ({
  checkout,
  uiOrderBumpsAplicados,
  uiSubtotal,
  discount,
}) => {
  const { t } = useTranslation();
  const appliedList =
    uiOrderBumpsAplicados ?? checkout?.orderBumpsAplicados ?? [];
  const subtotal = (uiSubtotal ?? checkout?.subtotal ?? 0) - discount;
  return (
    <S.SummaryContainer>
      <S.SummaryBox>
        <S.SummaryItem>
          <span>{checkout?.produto?.nome}</span>
          <span>{formatCurrency(checkout?.total, checkout?.moeda)}</span>
        </S.SummaryItem>

        {appliedList.map((order) => (
          <S.SummaryItem key={order.id} style={{ marginTop: '8px' }}>
            <span>{order?.produtoOferta?.nome}</span>
            <span>
              {formatCurrency(order?.precos?.[0]?.valor ?? 0, checkout.moeda)}
            </span>
          </S.SummaryItem>
        ))}

        {discount > 0 && (
          <S.SummaryItem style={{ marginTop: '8px' }}>
            <span>{t('discount')}</span>
            <span style={{ color: '#f84f4f' }}>
              - {formatCurrency(discount, checkout?.moeda)}
            </span>
          </S.SummaryItem>
        )}

        <S.Divider />

        <S.TotalRow>
          <span>{t('total')}</span>
          <span>{formatCurrency(subtotal, checkout?.moeda)}</span>
        </S.TotalRow>
      </S.SummaryBox>
    </S.SummaryContainer>
  );
};
